import { Badge } from '@/components/ui/badge'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { ProcessorDetails } from '@/lib/api/processors'
import { ProcessorHeader } from '../components/processor-header'
import { ProcessorOverviewCard } from '../components/processor-overview-card'
import { ProcessorMetricsCard } from '../components/processor-metrics-card'
import { ProcessorPaymentMethodsCard } from '../components/processor-payment-methods-card'

interface Props { processor: ProcessorDetails }

const GlobalPayConfigurationCard = ({ processor }: Props) => {
    const options = processor.options as Record<string, any> | null
    return (
        <Card className="mb-6">
            <CardHeader><CardTitle>Global Payments Configuration</CardTitle></CardHeader>
            <CardContent>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <p className="text-sm text-muted-foreground">App ID</p>
                        <p className="font-mono text-sm">{options?.appId || 'Not configured'}</p>
                    </div>
                    <div>
                        <p className="text-sm text-muted-foreground">App Key</p>
                        <p className="font-mono text-sm">••••••••••••••••</p>
                    </div>
                    {options?.merchantId && (
                        <div>
                            <p className="text-sm text-muted-foreground">Merchant ID</p>
                            <p className="font-mono text-sm">{options.merchantId}</p>
                        </div>
                    )}
                    <div>
                        <p className="text-sm text-muted-foreground">Environment</p>
                        <Badge variant={options?.testMode ? 'outline' : 'default'}>
                            {options?.testMode ? 'Sandbox' : 'Production'}
                        </Badge>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}

export const GlobalPayProcessorDetailsPage = ({ processor }: Props) => (
    <>
        <ProcessorHeader type="globalpay" processor={processor} />
        <ProcessorOverviewCard processor={processor} />
        <ProcessorMetricsCard processor={processor} />
        <GlobalPayConfigurationCard processor={processor} />
        <ProcessorPaymentMethodsCard processor={processor} />
    </>
)
